import { themePalette } from 'styles/colors/themePalette';

const getMuiAccordion = () => ({
  styleOverrides: {
    root: {
      borderTop: '1px solid '.concat(themePalette.semantic.interactive.surface.border.default),
      borderBottom: '1px solid '.concat(themePalette.semantic.interactive.surface.border.default),
      boxShadow: 'none',
      '&:not(:last-child)': {
        borderBottom: '1px solid '.concat(themePalette.semantic.interactive.surface.border.default),
        borderBottomColor: 'divider',
      },
      '&::before': {
        display: 'none',
      },
      '&.Mui-expanded': {
        borderTop: '1px solid'.concat(themePalette.semantic.interactive.surface.border.default),
        borderBottom: '1px solid'.concat(themePalette.semantic.interactive.surface.border.default),
        '&:not(:last-child)': {
          borderBottom: '1px solid'.concat(themePalette.semantic.interactive.surface.border.default),
        },
      },
      '& .MuiAccordionDetails-root': {
        paddingTop: '0px',
        paddingInline: '0px',
        paddingBottom: '12px',
        borderTop: '1px solid'.concat(themePalette.semantic.interactive.surface.border.default),
      },
      '& .MuiAccordionSummary-content': {
        '&.Mui-expanded': {
          margin: '12px 0',
        },
      },
      '& .MuiAccordionSummary-root': {
        '&.Mui-expanded': {
          minHeight: '48px',
        },
      },
    },
  },
});
export default getMuiAccordion;
